import { Dropzone, FileWithPath } from "@mantine/dropzone";
import { t } from "i18next";
import React from "react";
import { IoIosAddCircle } from "react-icons/io";
export const ACCEPT_FILE_TYPES = [
  "image/png",
  "image/gif",
  "image/jpeg",
  "image/jpg",
  "image/svg+xml",
  "image/webp",
  "image/avif",
  "image/epub",
  "application/pdf",
  "text/csv", // CSV-Format
  "application/vnd.ms-excel", // Excel-Format (xls)
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Excel-Format (xlsx)
  "application/excel", // ältere Excel-Formate
];

const AddImageCard = ({
  onSelectedFiles = () => {},
  disabled = false,
}: {
  onSelectedFiles?: (files: File[]) => void;
  disabled?: boolean;
}) => {
  const inputRef: any = React.useRef(null);

  // trigger when file is dropped
  const handleDrop = function (files: FileWithPath[]) {
    if (!files || files.length === 0) return;
    onSelectedFiles(files);
  };

  return (
    <Dropzone
      disabled={disabled}
      openRef={inputRef}
      accept={ACCEPT_FILE_TYPES}
      onDrop={handleDrop}
      className={`w-auto  p-0 ${
        disabled ? "pointer-events-none" : "cursor-pointer"
      }`}
      style={{
        borderRadius: "25px",
        border: "2px dashed #9C9C9C",
        background: "#FFF",
      }}
    >
      <div className="card-auto p-16 py-40">
        <div className="row row-column row-center row-v-center">
          <IoIosAddCircle
            size={"5rem"}
            className={`${disabled ? "color-grey" : "color-primary"}`}
          />
          <div className="row row-center row-v-center gap-4 ">
            {" "}
            <h4>
              <u>{t("selectOrDrag").toString()}</u>
            </h4>
            <p>{t("inFiles").toString()}</p>
          </div>
          <p
            style={{
              color: "#000",
              fontFamily: "Roboto",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
            }}
          >
            {t("allowedFileformats").toString()}
          </p>
        </div>
      </div>
    </Dropzone>
  );
};

export default AddImageCard;
